<template>
    <div :class="cn('flex items-stretch', props.class)">
        <slot />
    </div>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from "vue";

interface Props {
    class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
    class: "",
});
</script>
<style scoped>
div > *:not(:last-child) {
    @apply border-r-0 rounded-r-none;
}

div > *:not(:first-child) {
    @apply rounded-l-none;
}
</style>
